import React from "react";
import clsx from "clsx";
import Icon from "../../../../../../components/Icon";
import { TiCardWeeklyRatingData } from "../../../../@types";
import { RenderWhen } from "../../../../../../components";

interface Props {
  weeklyRankingData: TiCardWeeklyRatingData;
}

const TiCardWeeklyRank = ({ weeklyRankingData }: Props) => {
  const weeklyRankDelta =
    weeklyRankingData.previous_week - weeklyRankingData.current_week;

  if (!weeklyRankingData.current_week)
    return (
      <>
        <Icon
          className={clsx(
            weeklyRankingData.previous_week && "icon__down",
            "pdf-icon-right-margin"
          )}
          name={weeklyRankingData.previous_week ? "trending-down" : "empty"}
        />
        N/A
      </>
    );

  if (!weeklyRankingData.previous_week)
    return (
      <>
        <Icon
          className={"icon__up pdf-icon-right-margin"}
          name={"trending-up"}
        />
        {weeklyRankingData.current_week}
      </>
    );

  return (
    <>
      <RenderWhen condition={weeklyRankDelta !== 0}>
        <Icon
          className={clsx(
            weeklyRankDelta > 0 ? "icon__up" : "icon__down",
            "pdf-icon-right-margin"
          )}
          name={weeklyRankDelta > 0 ? "trending-up" : "trending-down"}
        />
      </RenderWhen>
      {weeklyRankingData.current_week}
      <span className="ticard-content__card-value__secondary">
        ({(weeklyRankDelta <= 0 ? "" : "+") + weeklyRankDelta})
      </span>
    </>
  );
};

export default TiCardWeeklyRank;
